import { handleAPIError } from "@services/Base";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { CLIENT_API_URL } from "../../../config";
import { IClientUpdate } from "../types";

export interface IPatchClientMutation {
  client_id: string;
  updates: IClientUpdate;
}

export const usePatchClient = () => {
  return useMutation({
    mutationFn: ({ client_id, updates }: IPatchClientMutation) => {
      const updates_fmt = {
        ...updates,
        kpi_label: undefined,
        name: undefined
      };
      return axios
        .patch(
          `${CLIENT_API_URL}/waves-client-manager-api/v1/clients/${client_id}`,
          updates_fmt
        )
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          return handleAPIError(error);
        });
    }
  });
};
